import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=6bf6d928&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=js&"
export * from "./pedidos.vue?vue&type=script&lang=js&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=6bf6d928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf6d928",
  null
  
)

export default component.exports